import DbSoftTree from "../db-soft-tree"
import {NiInput, NiButton} from "@/ni-ui"
import * as API from "@/api/index.js"

export default {
  name: "db-soft-select",
  components:{
    DbSoftTree,
    NiInput,
    NiButton,
  },

  model: {
    prop: 'target_value',
    event: 'change'
  },

  props:{
    target_value:{

    },

    select_width:{
      type: String,
      default: "",
    },

    value_field:{
        type:String,
        default:"id"
     },   // value 的取值字段

    only_parent:{
      type:String,
      default:"",    //1：只展示第一级节点数据
    },

    is_all: {
        type: String,
        default: "1",          // is_all 为 1 查询所有项目下的软件， 为 0 查询所属项目的软件
    },

    check_role: {      // 查看用户权限
        type: Object,
        default: function () {
            return {}
        }
    },

    support_soft_type:{
        type:String,
        default:""
    },

    model_type: {
        type: String,
        default: "0",    // 0 为字符串，1 为数组
    },

    disabled: {
      type: Boolean,
      default: false,
    },

    req_param: {
      type: Object,
      default: function () {
        return {"service":"server.database_tree","soft_type":["4"]}
      }
    },

  },

  data(){
    return{
      search_tree_visible: false,
      input_text: "",

      input_value: "",
      node_select_dict:{
        id: "",
        text: "",
      },

      popper_width: "600",

      popper_class_unique: require('node-uuid').v4(),

    }
  },

  created(){

  },


  mounted(){
    this.input_value = this.target_value
    this.check_input_text(this.target_value)

    this.get_select_node(this.target_value)

    this.check_popper_width()

  },

  watch:{

    input_text(val){

    },

    search_tree_visible(val){
      if(val){
        // this.check_popper_width()
      } else {
        this.check_input_text(this.input_value)
      }
    },

    select_width(val){
      this.check_popper_width()
    },

    input_value(val){
      this.$emit("change", val)
    },

    target_value(val){
      if(this.input_value !== val){
        this.check_input_text(val)
      }
      this.get_select_node(val)

      this.input_value = val


    },
  },

  methods:{

    check_popper_width(){
      this.popper_width = this.select_width
      this.$nextTick(() =>{

        if(!this.select_width){
          let target_width = this.$el.querySelector(".node-text-input").offsetWidth - 24

          if(target_width){
              this.popper_width = target_width < 250 ? 250: target_width
          }


        }
      })

    },

    check_input_text(val){
      if(!val && this.input_text){
        this.input_text = ""
        if(this.$refs.search_tree){
          this.$refs.search_tree.search_tree_form.search_content = this.input_text
          this.$refs.search_tree.search_data()
        }
      }
    },



    input_focus(){
      // this.search_tree_visible = true
      this.check_popper_width()
      // this.hidden_dom()
    },

    node_click(node){
      if(this.model_type === '1') return;
      this.input_value = node[this.value_field]
      this.input_text = node.db_info
      this.node_select_dict.id = node[this.value_field]
      this.node_select_dict.text = node.db_info
      this.search_tree_visible = false
      this.$emit("node_select", node)
    },

    node_checked(nodes){
      if(this.model_type === '0') return;
      this.input_value = nodes.map(node => node[this.value_field])
      this.input_text = nodes.map(node => node.db_info).join(",")
      this.node_select_dict.id = nodes.map(node => node[this.value_field])
      this.node_select_dict.text = nodes.map(node => node.db_info).join(",")
      this.$emit("node_select", nodes)
    },


    get_select_node(value){
      if(value && (JSON.stringify(this.node_select_dict.id) != JSON.stringify(value) || !this.input_text)){
        this.$refs.search_tree.select_target_node(value)
        // if(node){
        //   this.input_text = node.orginal
        //   this.node_select_dict.id = node[this.value_field]
        //   this.node_select_dict.text = node.orginal
        //   this.$emit("node_select", node)
        // }
      }

    },


  }


}



// WEBPACK FOOTER //
// ./src/omnis-business/db-soft-select/db-soft-select.js